import React from "react";
import {
  MDBBadge,
  MDBIcon,
  MDBBtn,
  MDBTable,
  MDBTableHead,
  MDBTableBody,
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBBtnGroup,
} from "mdb-react-ui-kit";
import { Link } from "react-router-dom";
import "./MisCuentas.css";

import profile_default from "images/profile_default.png";

import { doFetch } from "Projects/CC_cubi_clan_project/Utils/ConnectionManager";
import { PopConfirm } from "Projects/CC_cubi_clan_project/GlobalComponents/PopConfirm/PopConfirm";
import { AccountNewModal } from "../AccountNewModal/AccountNewModal";
import { AccountEditModal } from "../AccountEditModal/AccountEditModal";
import { CircleImage } from "Projects/CC_cubi_clan_project/GlobalComponents/CircleImage/CircleImage";
import { UsuariosCCONModal } from "../UsuariosCCONModal/UsuariosCCONModal";
import { AccountLinkModal } from "../AccountLinkModal/AccountLinkModal";
import { CategoriasModal } from "../CategoriasModal/CategoriasModal";
import { GrupoNewModal } from "../GrupoNewModal/GrupoNewModal";
import { GrupoEditModal } from "../GrupoEditModal/GrupoEditModal";

export class MisCuentas extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      cuentas: [],
      grupos: [],
      showAccountNewModal: false,
      showAccountEditModal: false,
      showAccountDeleteAlert: false,
      showUsuariosCCONModal: false,
      showAccountLinkModal: false,
      showCategoriasModal: false,
      showGrupoNewModal: false,
      showGrupoEditModal: false,
      showGrupoDeleteAlert: false,
      selectedAccountEdit: null,
      selectedAccountDelete: null,
      selectedAccountLink: null,
      selectedGrupoEdit: null,
      selectedGrupoDelete: null,
    };
  }

  componentDidMount() {
    this.getCuentas();
    this.getGrupos();
  }

  getCuentas() {
    this.props.onLoading(true);

    doFetch("CCON", "getUserAccounts", null)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({ cuentas: this.processCuentasResult(data.DATA) });
      })
      .catch((error) => {
        console.error(
          "Error al obtener datos:",
          JSON.stringify(error, null, 2)
        );
      })
      .finally(() => {
        this.props.onLoading(false);
      });
  }

  processCuentasResult(cuentasInputData) {
    this.props.onLoading(true);

    let dataResultMap = new Map();
    let dataResult = [];

    for (let cuentaUserInfo of cuentasInputData) {
      let userInfo;
      if (cuentaUserInfo.IDUsuarioCCONFK) {
        userInfo = {
          ...cuentaUserInfo.IDUsuarioCCONFK,
          tipo: "CCON",
          participacion: cuentaUserInfo.participacion,
        };
      } else {
        userInfo = Object.assign({}, cuentaUserInfo.IDUsuarioFK, {
          tipo: "SSO",
          participacion: cuentaUserInfo.participacion,
        });
      }

      if (!dataResultMap.has(cuentaUserInfo.IDCuentaFK.IDCuenta)) {
        let cuentaInfo = Object.assign(cuentaUserInfo.IDCuentaFK, {
          propietarios: [userInfo],
        });
        dataResultMap.set(cuentaInfo.IDCuenta, cuentaInfo);
      } else {
        dataResultMap
          .get(cuentaUserInfo.IDCuentaFK.IDCuenta)
          .propietarios.push(userInfo);
      }
    }

    dataResult = Array.from(dataResultMap.values());

    this.props.onLoading(false);

    return dataResult;
  }

  setNewAccount() {
    this.setState({ showAccountNewModal: true });
  }

  setEditAccount(element) {
    this.setState({ showAccountEditModal: true, selectedAccountEdit: element });
  }

  handleCloseModal() {
    this.setState({ showAccountEditModal: false, showAccountNewModal: false, showUsuariosCCONModal: false, showCategoriasModal: false });
    this.getCuentas();
  }

  handleCloseGrupoModal(refresh) {
    this.setState({ showGrupoNewModal: false, showGrupoEditModal: false, selectedGrupoEdit: null });
    if (refresh) {
      this.getGrupos();
    }
  }

  handleCloseLinkModal(refresh) {
    this.setState({ showAccountLinkModal: false, selectedAccountLink: null });
    if (refresh) this.getCuentas();
  }

  confirmAccountDelete(element) {
    this.setState({
      showAccountDeleteAlert: true,
      selectedAccountDelete: element,
    });
  }

  async handlerConfirmDeleteAccount() {
    this.setState({ showAccountDeleteAlert: false });
    let res = await this.deleteAccount();
    if (res) {
      this.getCuentas();
    }
  }

  handlerCancelDeleteAccount() {
    this.setState({
      showAccountDeleteAlert: false,
      selectedAccountDelete: null,
    });
  }

  async deleteAccount() {
    let result = false;

    this.props.onLoading(true);

    const requestOptions = {
      method: "DELETE",
    };

    this.props.onLoading(true);

    let method =
      "deleteAccount?IDCuenta=" + this.state.selectedAccountDelete.IDCuenta;

    await doFetch("CCON", method, requestOptions)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.STATE === "SUCCESS") {
          result = true;
        }
      })
      .catch((error) => {
        console.error(
          "Error al obtener datos:",
          JSON.stringify(error, null, 2)
        );
      })
      .finally(() => {
        this.props.onLoading(false);
      });

    return result;
  }

  async getGrupos() {
    this.props.onLoading(true);

    await doFetch("CCON", "getGruposUsuario", null)
      .then((response) => response.json())
      .then((data) => {
        this.setState({ grupos: data.STATE === "SUCCESS" ? (data.DATA || []) : [] });
      })
      .catch((error) => {
        console.error("Error al obtener grupos:", JSON.stringify(error, null, 2));
      })
      .finally(() => {
        this.props.onLoading(false);
      });
  }

  setNewGrupo() {
    this.setState({ showGrupoNewModal: true });
  }

  setEditGrupo(grupo) {
    this.setState({ showGrupoEditModal: true, selectedGrupoEdit: grupo });
  }

  confirmGrupoDelete(grupo) {
    this.setState({ showGrupoDeleteAlert: true, selectedGrupoDelete: grupo });
  }

  async handlerConfirmDeleteGrupo() {
    this.setState({ showGrupoDeleteAlert: false });
    const res = await this.deleteGrupo();
    if (res) {
      this.getGrupos();
    }
  }

  handlerCancelDeleteGrupo() {
    this.setState({ showGrupoDeleteAlert: false, selectedGrupoDelete: null });
  }

  async deleteGrupo() {
    let result = false;

    this.props.onLoading(true);

    const requestOptions = {
      method: "DELETE",
    };

    const method =
      "deleteGrupo?IDGrupo=" + this.state.selectedGrupoDelete.IDGrupo;

    await doFetch("CCON", method, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        result = data.STATE === "SUCCESS";
      })
      .catch((error) => {
        console.error("Error al eliminar grupo:", JSON.stringify(error, null, 2));
      })
      .finally(() => {
        this.props.onLoading(false);
      });

    return result;
  }

  handleLinkClick = (event) => {
    event.preventDefault();

    this.props.onHandleNavLinks(null, event.currentTarget.getAttribute("href"));
  };

  formatCurrency(value, locale = "es-ES", currency = "EUR", options = {}) {
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency: currency,
      ...options,
    }).format(value);
  }

  formatDouble(value) {
    // Usar toFixed para fijar el número de decimales a 2
    let formattedValue = Number(value).toFixed(2);

    // Convertir el resultado a cadena si es necesario
    return formattedValue.toString();
  }

  render() {
    return (
      <MDBContainer fluid>
        {this.state.showCategoriasModal && (
          <CategoriasModal
            onClose={() => this.setState({ showCategoriasModal: false })}
            onLoading={(event) => this.props.onLoading(event)}
          />
        )}
        {this.state.showAccountLinkModal && this.state.selectedAccountLink ? (
          <AccountLinkModal
            cuenta={this.state.selectedAccountLink}
            cuentasPersonales={this.state.cuentas.filter((c) => !c.tipo || c.tipo === "PERSONAL")}
            onClose={(refresh) => this.handleCloseLinkModal(refresh)}
            onLoading={(event) => this.props.onLoading(event)}
          />
        ) : (
          <></>
        )}
        {this.state.showUsuariosCCONModal ? (
          <UsuariosCCONModal
            show={this.state.showUsuariosCCONModal}
            onClose={() => this.handleCloseModal()}
            onLoading={(event) => this.props.onLoading(event)}
          />
        ) : (
          <></>
        )}
        {this.state.showAccountEditModal ? (
          <AccountEditModal
            showAccountEditModal={this.state.showAccountEditModal}
            data={this.state.selectedAccountEdit}
            onCloseModal={() => this.handleCloseModal()}
            onLoading={(event) => this.props.onLoading(event)}
          />
        ) : (
          <></>
        )}
        {this.state.showAccountNewModal ? (
          <AccountNewModal
            showAccountNewModal={this.state.showAccountNewModal}
            onCloseModal={() => this.handleCloseModal()}
            onLoading={(event) => this.props.onLoading(event)}
          />
        ) : (
          <></>
        )}
        {this.state.showGrupoNewModal ? (
          <GrupoNewModal
            show={this.state.showGrupoNewModal}
            cuentasDisponibles={this.state.cuentas.filter((c) => ["PERSONAL", "SHARED_EXPENSE"].includes(c.tipo || "PERSONAL"))}
            onClose={(refresh) => this.handleCloseGrupoModal(refresh)}
            onLoading={(event) => this.props.onLoading(event)}
          />
        ) : (
          <></>
        )}
        {this.state.showGrupoEditModal && this.state.selectedGrupoEdit ? (
          <GrupoEditModal
            show={this.state.showGrupoEditModal}
            data={this.state.selectedGrupoEdit}
            cuentasDisponibles={this.state.cuentas.filter((c) => ["PERSONAL", "SHARED_EXPENSE"].includes(c.tipo || "PERSONAL"))}
            onClose={(refresh) => this.handleCloseGrupoModal(refresh)}
            onLoading={(event) => this.props.onLoading(event)}
          />
        ) : (
          <></>
        )}
        {this.state.showAccountDeleteAlert ? (
          <PopConfirm
            show={this.state.showAccountDeleteAlert}
            title="Confirmar borrar cuenta"
            detail="¿Está seguro de que desea borrar la cuenta?"
            onConfirm={() => this.handlerConfirmDeleteAccount()}
            onCancel={() => this.handlerCancelDeleteAccount()}
          />
        ) : (
          <></>
        )}
        {this.state.showGrupoDeleteAlert ? (
          <PopConfirm
            show={this.state.showGrupoDeleteAlert}
            title="Confirmar borrar grupo"
            detail="¿Está seguro de que desea borrar el grupo?"
            onConfirm={() => this.handlerConfirmDeleteGrupo()}
            onCancel={() => this.handlerCancelDeleteGrupo()}
          />
        ) : (
          <></>
        )}
        <MDBContainer fluid className="mt-3">
          <MDBRow end>
            <MDBCol size="auto">
              <MDBBtnGroup>
                <MDBBtn onClick={() => this.setNewAccount()}>
                  Nueva cuenta
                </MDBBtn>
                <MDBBtn color="info" onClick={() => this.setState({ showCategoriasModal: true })}>
                  Categorías
                </MDBBtn>
                <MDBBtn color="secondary" onClick={() => this.setState({ showUsuariosCCONModal: true })}>
                  Colaboradores
                </MDBBtn>
                <MDBBtn color="dark" onClick={() => this.setNewGrupo()}>
                  Nuevo grupo
                </MDBBtn>
              </MDBBtnGroup>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
        {/* ── Resumen por tipo de cuenta ── */}
        {(() => {
          const sumByType = (tipo) =>
            this.state.cuentas
              .filter((c) => (c.tipo || "PERSONAL") === tipo)
              .reduce((acc, c) => acc + (c.saldo || 0), 0);
          const personal = sumByType("PERSONAL");
          const compartida = sumByType("SHARED_EXPENSE");
          const presupuesto = sumByType("BUDGET");
          const tipos = [
            { label: "Personal", value: personal, color: "#1266f1" },
            { label: "Gastos compartidos", value: compartida, color: "#0097a7" },
            { label: "Presupuestos", value: presupuesto, color: "#e65100" },
          ];
          return (
            <div className="balance-summary">
              {tipos.map(({ label, value, color }) => (
                <div key={label} className="balance-summary-card">
                  <span className="balance-summary-label" style={{ color }}>
                    {label}
                  </span>
                  <span
                    className="balance-summary-value"
                    style={{ color: value >= 0 ? "#00796b" : "#c62828" }}
                  >
                    {this.formatCurrency(value)}
                  </span>
                </div>
              ))}
            </div>
          );
        })()}
        <MDBTable align="middle" striped hover responsive className="mis-cuentas">
          <MDBTableHead>
            <tr>
              <th scope="col">Nombre</th>
              <th scope="col">Saldo</th>
              <th scope="col">Propietarios</th>
              <th scope="col">Participación</th>
              <th scope="col">Actions</th>
            </tr>
          </MDBTableHead>
          <MDBTableBody>
            {this.state.cuentas.filter((c) => (c.tipo || "PERSONAL") !== "BUDGET").map((element, index) => (
              <tr key={index}>
                <td>
                  <Link
                    to={`/ccon/cuenta/${element.IDCuenta}`}
                    onClick={this.handleLinkClick}
                  >
                    {element.nombre}
                  </Link>
                  {element.tipo && element.tipo !== "PERSONAL" && (
                    <MDBBadge
                      className="ms-2"
                      color={element.tipo === "SHARED_EXPENSE" ? "info" : "warning"}
                      pill
                      light
                    >
                      {element.tipo === "SHARED_EXPENSE" ? "Compartida" : "Presupuesto"}
                    </MDBBadge>
                  )}
                </td>
                <td>
                  <MDBBadge
                    color={element.saldo >= 0 ? "success" : "danger"}
                    pill
                  >
                    {this.formatCurrency(element.saldo, "es-ES", "EUR")}
                  </MDBBadge>
                </td>
                <td>
                  {element.propietarios.map((propietario, idx) => (
                    <tr key={idx}>
                      <td className="text-muted px-1">
                        <CircleImage
                          src={
                            propietario.userImg
                              ? propietario.userImg
                              : profile_default
                          }
                          alt={propietario.apodo}
                          size="15px"
                          enlargeOnHover={true}
                        />
                      </td>
                      <td className="text-muted">
                        {propietario.apodo}
                      </td>
                    </tr>
                  ))}
                </td>
                <td>
                  {element.propietarios.map((propietario, idx) => (
                    <tr key={idx}>
                      <td className="text-muted mb-0">
                      {this.formatDouble(propietario.participacion)} %
                      </td>
                    </tr>
                  ))}
                </td>
                <td>
                  {element.tipo === "SHARED_EXPENSE" && (
                    <button
                      className="action-btn btn-link"
                      title="Asociar a cuenta personal"
                      onClick={() => this.setState({ showAccountLinkModal: true, selectedAccountLink: element })}
                    >
                      <MDBIcon icon="link" />
                    </button>
                  )}
                  <button
                    className="action-btn btn-edit"
                    title="Editar"
                    onClick={() => this.setEditAccount(element)}
                  >
                    <MDBIcon icon="edit" />
                  </button>
                  <button
                    className="action-btn btn-delete"
                    title="Eliminar"
                    onClick={() => this.confirmAccountDelete(element)}
                  >
                    <MDBIcon icon="times" />
                  </button>
                </td>
              </tr>
            ))}
          </MDBTableBody>
          <tfoot>
            {(() => {
              const totalSaldo = this.state.cuentas
                .filter((c) => !c.tipo || c.tipo === "PERSONAL")
                .reduce((acc, c) => acc + (c.saldo || 0), 0);
              return (
                <tr className="fw-bold">
                  <td>Total</td>
                  <td>
                    <MDBBadge
                      color={totalSaldo >= 0 ? "success" : "danger"}
                      pill
                    >
                      {this.formatCurrency(totalSaldo)}
                    </MDBBadge>
                  </td>
                  <td colSpan={3} />
                </tr>
              );
            })()}
          </tfoot>
        </MDBTable>

        {this.state.cuentas.some((c) => c.tipo === "BUDGET") && (
          <div className="mt-4">
            <h5 className="mb-3">Mis presupuestos</h5>
            <MDBTable align="middle" striped hover responsive className="mis-cuentas">
              <MDBTableHead>
                <tr>
                  <th scope="col">Nombre</th>
                  <th scope="col">Total planificado</th>
                  <th scope="col">Propietarios</th>
                  <th scope="col">Acciones</th>
                </tr>
              </MDBTableHead>
              <MDBTableBody>
                {this.state.cuentas.filter((c) => c.tipo === "BUDGET").map((element, index) => (
                  <tr key={index}>
                    <td>
                      <Link
                        to={`/ccon/cuenta/${element.IDCuenta}`}
                        onClick={this.handleLinkClick}
                      >
                        {element.nombre}
                      </Link>
                      <MDBBadge className="ms-2" color="warning" pill light>
                        Presupuesto
                      </MDBBadge>
                    </td>
                    <td>
                      <MDBBadge color={element.saldo >= 0 ? "primary" : "danger"} pill>
                        {this.formatCurrency(element.saldo, "es-ES", "EUR")}
                      </MDBBadge>
                    </td>
                    <td>
                      {element.propietarios.map((propietario, idx) => (
                        <div
                          key={idx}
                          className="d-flex align-items-center gap-2 py-1"
                        >
                          <CircleImage
                            src={
                              propietario.userImg
                                ? propietario.userImg
                                : "/images/logo/logo_simple_white.png"
                            }
                            size={30}
                            alt={propietario.userName}
                          />
                          <span className="text-muted">{propietario.userName}</span>
                          <MDBBadge color="secondary" pill>
                            {this.formatDouble(propietario.participacion)}%
                          </MDBBadge>
                        </div>
                      ))}
                    </td>
                    <td>
                      <button
                        className="action-btn btn-edit"
                        title="Editar"
                        onClick={() => this.setEditAccount(element)}
                      >
                        <MDBIcon icon="edit" />
                      </button>
                      <button
                        className="action-btn btn-delete"
                        title="Eliminar"
                        onClick={() => this.confirmAccountDelete(element)}
                      >
                        <MDBIcon icon="times" />
                      </button>
                    </td>
                  </tr>
                ))}
              </MDBTableBody>
            </MDBTable>
          </div>
        )}

        <div className="mt-4">
          <h5 className="mb-3">Mis grupos</h5>
          <MDBTable align="middle" striped hover responsive className="mis-cuentas mis-grupos">
            <MDBTableHead>
              <tr>
                <th scope="col">Nombre</th>
                <th scope="col">Saldo</th>
                <th scope="col">N.º cuentas</th>
                <th scope="col">Cuentas</th>
                <th scope="col">Acciones</th>
              </tr>
            </MDBTableHead>
            <MDBTableBody>
              {this.state.grupos.map((grupo) => (
                <tr key={grupo.IDGrupo}>
                  <td>{grupo.nombre}</td>
                  <td>
                    <span className={Number(grupo.balance) >= 0 ? "text-success fw-semibold" : "text-danger fw-semibold"}>
                      {this.formatCurrency(grupo.balance || 0)}
                    </span>
                  </td>
                  <td>
                    <MDBBadge color="info" pill>
                      {grupo.numCuentas || 0}
                    </MDBBadge>
                  </td>
                  <td>
                    {Array.isArray(grupo.cuentas) && grupo.cuentas.length > 0
                      ? grupo.cuentas.map((c) => c.nombre).join(", ")
                      : "Sin cuentas"}
                  </td>
                  <td>
                    <button
                      className="action-btn btn-view"
                      title="Ver detalle del grupo"
                      onClick={() => this.props.onNavigate("/ccon/grupo/" + grupo.IDGrupo)}
                    >
                      <MDBIcon icon="eye" />
                    </button>
                    <button
                      className="action-btn btn-edit"
                      title="Editar"
                      onClick={() => this.setEditGrupo(grupo)}
                    >
                      <MDBIcon icon="edit" />
                    </button>
                    <button
                      className="action-btn btn-delete"
                      title="Eliminar"
                      onClick={() => this.confirmGrupoDelete(grupo)}
                    >
                      <MDBIcon icon="times" />
                    </button>
                  </td>
                </tr>
              ))}
              {this.state.grupos.length === 0 && (
                <tr>
                  <td colSpan={5} className="text-muted text-center py-4">
                    No tienes grupos creados.
                  </td>
                </tr>
              )}
            </MDBTableBody>
          </MDBTable>
        </div>
      </MDBContainer>
    );
  }
}
